var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_512_7705)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.5 20.3848L14.5575 18.4424L13.5 19.5L16.5 22.5L22.5 16.5L21.4424 15.4425L16.5 20.3848Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 12.75H6.75V14.25H12V12.75Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.75 9H6.75V10.5H15.75V9Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.75 5.25H6.75V6.75H15.75V5.25Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 22.5H4.5C3.67275 22.5 3 21.8271 3 21V3C3 2.1729 3.67275 1.5 4.5 1.5H18C18.8273 1.5 19.5 2.1729 19.5 3V14.25H18V3H4.5V21H12V22.5Z",
  fill: "currentColor"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_512_7705"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})));

var SvgWepaIcon = function SvgWepaIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWepaIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/WepaIcon.d80d5c31.svg";
export { ForwardRef as ReactComponent };